export default "__VITE_ASSET__7M3aOYqz__"